import React from 'react';
import './Tabs.css';

const Tabs = ({ selectedTab, onSelectTab }) => {
  return (
    <div className="tabs">
      <button
        className={`tab-button ${selectedTab === 'Latest' ? 'active' : ''}`}
        onClick={() => onSelectTab('Latest')}
      >
        Latest
      </button>
      <button
        className={`tab-button ${selectedTab === 'Trending' ? 'active' : ''}`}
        onClick={() => onSelectTab('Trending')}
      >
        Trending
      </button>
    </div>
  );
};

export default Tabs;
